import {axios} from "react-netjoy";

const ResponseSuccessInterceptor: axios.AxiosInterceptorResponseSuccessInputFunctionType<{}> = (response, serviceClient) => {
    console.log('ResponseSuccessInterceptor')
    console.log(JSON.stringify(response))
    return response
}

export default ResponseSuccessInterceptor;
